//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MNavSubitem',
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    activeNames: {
      type: Array,
      default: () => [],
    },
    props: {
      type: Object,
      default() {
        return {
          children: 'children',
          label: 'label',
          index: 'id',
        }
      },
    },
  },
  data() {
    return {
      clickFlag: null,
    }
  },
  methods: {
    onGetMenu(item) {
      this.$emit('getmenu', item)
    },
    handleClickItem(item) {
      this.onGetMenu(item)
    },
  },
}
